export const PRECOMMITMENT_API_PATH_PREFIX = '/api/precommitment/'
export const PRECOMMITMENT_ROUTE = 'account/precommitment'

export const DEFAULT_COOLING_OFF_PERIOD_DAYS = 7
